import {Switch} from 'platform/components';
import {HStack, Image, Show} from 'platform/foundation';
import styled from 'styled-components';

import {AdServer} from '../../../types/AdServer';

const AdServerLabel = styled.label<{$isDisabled: boolean}>`
  cursor: ${({$isDisabled}) => ($isDisabled ? 'default' : 'pointer')};
`;

export interface AdServerSwitcherProps {
  adServer: AdServer;
  value: boolean;
  onChange: (value: boolean) => void;
  showSwitch: boolean;
}

export function AdServerSwitcher(props: AdServerSwitcherProps) {
  const externalLabelId = `${props.adServer}-switch`;

  return (
    <HStack spacing={2} align="center">
      <Show when={props.showSwitch}>
        <Switch externalLabelId={externalLabelId} value={props.value} onChange={props.onChange} />
      </Show>
      <AdServerLabel
        $isDisabled={!props.showSwitch}
        htmlFor={props.showSwitch ? externalLabelId : undefined}
      >
        <Image
          src={`/assets/images/ad-server-logo/${props.adServer}.svg`}
          maxHeight={5}
          fit="contain"
          position="left"
        />
      </AdServerLabel>
    </HStack>
  );
}
